import * as React from 'react';
import './SingleStudentSessionDetails.css';
import {
  Box,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Avatar,
  Modal,
  Button,
} from '@mui/material';
import AdminNavbar from '../../../../../components/Admin/AdminNavbar/AdminNavbar';
import Layout from '../../../../../components/Layout';
import { useNavigate, useParams } from 'react-router-dom';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
// import { axiosInstance } from '../../../../../utils/tokenUtils'
import { useCallback } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
// import { useCallback } from 'react';
import StudentEnableModal from '../../../../../components/Admin/UserManagement/Student/StudentEnableModal/StudentEnableModal';
import CalenderIcon from '../../../../../assets/Admin/SessionIcons/calender-icon.svg';
import ClockIcon from '../../../../../assets/Admin/SessionIcons/clock-icon.svg';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import { axiosInstance } from '../../../../../utils/tokenUtils';

// Initialize dayjs plugins for timezone conversion
dayjs.extend(utc);
dayjs.extend(timezone);

const StatusColor = {
  enable: { color: '#14B334', bgcolor: '#F2FFF5', value: 'Enabled' },
  disable: { color: '#949DA6', bgcolor: '#F5F5F5', value: 'Disabled' },
};

const SessionTypeColor = {
  one_on_one: { color: '#0A5EF3', bgcolor: '#E8F0FF', value: 'One-On-One Session' },
  group: { color: '#7BCF8C', bgcolor: '#FAFFFB', value: 'Group Session' },
  prime: { color: '#6B60E7', bgcolor: '#F0EFFF', value: 'Prime Session' },
};

// Helper function to convert UTC time to local time
const toLocalTime = utcTime => {
  if (!utcTime) return null;
  return dayjs.utc(utcTime).local();
};

const SingleStudentSessionDetails = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [rowId, setRowId] = useState(null);
  const [studentName, setStudentName] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [sessionDetails, setSessionDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openVideoPlayer, setOpenVideoPlayer] = useState(false);
  const [selectedRecordingIndex, setSelectedRecordingIndex] = useState(0);
  const [videoError, setVideoError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const getSingleSessionDetails = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get(`/admin/sessions/id/${id}`);
      setSessionDetails(data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    getSingleSessionDetails();
  }, [getSingleSessionDetails]);

  const handleMenuClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAction = action => {
    if (action === 'disable') {
      setOpenApproveModal(true);
      setRowId(sessionDetails?.students?.[0]?.user?.id);
      setStudentName(sessionDetails?.students?.[0]?.user?.name);
      setIsActive(sessionDetails?.students?.[0]?.user?.is_active);
    } else if (action === 'enable') {
      setOpenApproveModal(true);
      setRowId(sessionDetails?.students?.[0]?.user?.id);
      setStudentName(sessionDetails?.students?.[0]?.user?.name);
      setIsActive(sessionDetails?.students?.[0]?.user?.is_active);
    }
    handleMenuClose();
  };

  const formatTimeInterval = (startTime, lengthInMinutes) => {
    if (!startTime || !lengthInMinutes) return '---';

    const localStartTime = toLocalTime(startTime);
    const localEndTime = localStartTime.add(lengthInMinutes, 'minute');

    // Different scenarios
    const startHour = localStartTime.format('h:mm');
    const endHour = localEndTime.format('h:mm');
    const startPeriod = localStartTime.format('A');
    const endPeriod = localEndTime.format('A');

    // Handling AM/PM transition
    if (startPeriod !== endPeriod) {
      return `${startHour} ${startPeriod} - ${endHour} ${endPeriod}`;
    }

    // Same period (AM or PM)
    return `${startHour} - ${localEndTime.format('h:mm A')}`;
  };

  const formatDate = dateString => {
    if (!dateString) return '---';
    return toLocalTime(dateString).format('DD-MM-YYYY');
  };

  const formatDateLong = dateString => {
    if (!dateString) return '---';
    return toLocalTime(dateString).format('DD MMM, YYYY');
  };

  const handleOpenVideoPlayer = (index = 0) => {
    setSelectedRecordingIndex(index);
    setOpenVideoPlayer(true);
  };

  const handleCloseVideoPlayer = () => {
    setOpenVideoPlayer(false);
    setSelectedRecordingIndex(0);
    setVideoError(false);
  };

  if (loading) {
    return (
      <Layout title="Klass Online | Session Details">
        <Box className="flex justify-center items-center h-screen">
          <Typography>Loading session details...</Typography>
        </Box>
      </Layout>
    );
  }

  if (!sessionDetails) {
    return (
      <Layout title="Klass Online | Session Details">
        <Box className="flex justify-center items-center h-screen">
          <Typography>No session details found</Typography>
        </Box>
      </Layout>
    );
  }

  return (
    <Layout title="Klass Online | Settings">
      <Box className="relative h-screen w-full overflow-hidden">
        <Box className="sticky top-0 left-0 right-0 z-[1000] bg-white pr-[10px]">
          <AdminNavbar />
        </Box>
        <Box className="h-[calc(100vh-64px)] overflow-auto relative bg-[#F9F9F9] rounded-lg mr-[10px]">
          <Box className="flex flex-col p-[1rem] gap-3">
            <Box className="flex justify-between items-center">
              <Box className="flex flex-col">
                <Box className="flex items-center gap-2">
                  <Typography
                    className="user-management-request-text"
                    onClick={() => {
                      if (sessionDetails?.students?.[0]?.user?.id) {
                        navigate(
                          `/admin/users/learner-details/${sessionDetails.students[0].user.id}`
                        );
                      } else {
                        navigate('/admin/users/learner');
                      }
                    }}
                  >
                    User Management {'>'}
                    {'>'} Learner {'>'}
                    {'>'} Profile {'>'}
                    {'>'}
                  </Typography>
                  <Typography className="profile-text">Session</Typography>
                </Box>
                <Box className="flex items-center gap-4">
                  <Typography className="teacher-request-name-text">
                    {sessionDetails?.students?.[0]?.user?.name || '---'}
                  </Typography>
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                      height: '16px',
                      mt: 1,
                      borderColor: '#D5DEE3',
                    }}
                  />
                  <Box
                    sx={{
                      height: '30px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      padding: '4px 8px 4px 8px',
                      borderRadius: '20px',
                      backgroundColor: sessionDetails?.students?.[0]?.user?.is_active
                        ? StatusColor['enable']?.bgcolor
                        : StatusColor['disable']?.bgcolor,
                      color: sessionDetails?.students?.[0]?.user?.is_active
                        ? StatusColor['enable']?.color
                        : StatusColor['disable']?.color,
                      border: `1px solid ${
                        sessionDetails?.students?.[0]?.user?.is_active
                          ? StatusColor['enable']?.color
                          : StatusColor['disable']?.color
                      }`,
                      fontFamily: 'Poppins !important',
                      fontSize: '10px !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      lineHeight: 'normal !important',
                    }}
                  >
                    <Typography
                      className="w-[6px] h-[6px] rounded-full"
                      style={{
                        backgroundColor: sessionDetails?.students?.[0]?.user?.is_active
                          ? StatusColor['enable']?.color
                          : StatusColor['disable']?.color,
                      }}
                    ></Typography>
                    <Typography className="status-text">
                      {sessionDetails?.students?.[0]?.user?.is_active ? 'Enabled' : 'Disabled'}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box className="flex items-center gap-4">
                <IconButton onClick={handleMenuClick}>
                  <MoreHorizOutlinedIcon />
                </IconButton>
              </Box>
            </Box>
            <Box className="session-details-container">
              {sessionDetails?.status === 'cancelled' && (
                <Box className="single-cancel-session-details-container">
                  <Box className="flex">
                    <Typography className="cancelled-on-text">Cancelled On</Typography>
                    <Typography className="cancelled-on-text">
                      {sessionDetails?.cancelled_at
                        ? formatDateLong(sessionDetails.cancelled_at)
                        : '---'}
                    </Typography>
                  </Box>
                  <Box className="flex gap-4">
                    <Typography className="cancelled-by-text">Reason</Typography>
                    <Typography className="cancelled-by-value">
                      {sessionDetails?.cancellation_reason || '---'}
                    </Typography>
                  </Box>
                  <Box className="flex gap-4">
                    <Typography className="cancelled-by-text">Cancelled By</Typography>
                    <Typography className="cancelled-by-value">
                      {sessionDetails?.cancelled_by === 'teacher'
                        ? 'Instructor'
                        : sessionDetails?.cancelled_by === 'student'
                          ? 'Me'
                          : '---'}
                    </Typography>
                  </Box>
                </Box>
              )}
              <Box className="single-session-details-container">
                <Box className="flex items-center justify-between gap-3">
                  <Typography className="session-title-text">
                    {sessionDetails?.subject || '---'}
                  </Typography>
                  <Typography
                    className="session-type-text"
                    sx={{ color: SessionTypeColor[sessionDetails?.session_type]?.color }}
                  >
                    {sessionDetails?.session_type
                      ? SessionTypeColor[sessionDetails?.session_type]?.value
                      : '---'}
                  </Typography>
                </Box>
                {sessionDetails?.tags && sessionDetails.tags.length > 0 && (
                  <Box className="flex gap-2 flex-wrap mt-2">
                    {sessionDetails.tags.map((tag, index) => (
                      <Box
                        key={index}
                        sx={{
                          padding: '4px 8px',
                          borderRadius: '16px',
                          backgroundColor: '#E8F0FF',
                          color: '#0A5EF3',
                          fontSize: '12px',
                        }}
                      >
                        {tag}
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
              <Box className="single-session-details-container">
                <Box className="flex gap-8">
                  <Box className="flex justify-center items-center gap-4">
                    <img src={CalenderIcon} alt="Calender" />
                    <Box className="flex flex-col">
                      <Typography className="date-heading-text">Date</Typography>
                      <Typography className="date-heading-value">
                        {sessionDetails?.start_time ? formatDate(sessionDetails.start_time) : '---'}
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="flex justify-center items-center gap-4">
                    <img src={ClockIcon} alt="Calender" />
                    <Box className="flex flex-col">
                      <Typography className="date-heading-text">Timing</Typography>
                      <Typography className="date-heading-value">
                        {sessionDetails?.start_time
                          ? formatTimeInterval(
                              sessionDetails.start_time,
                              sessionDetails.length_in_minutes
                            )
                          : '---'}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box className="class-with-container">
                <Typography className="section-title">Class with</Typography>
                <Box className="teacher-info">
                  <Avatar
                    src={sessionDetails?.teacher?.profile_image || '/placeholder.jpg'}
                    alt={sessionDetails?.teacher?.name}
                  />
                  <Box className="teacher-details">
                    <Typography className="teacher-name">
                      {sessionDetails?.teacher?.name || '---'}
                    </Typography>
                    <Typography className="teacher-email">
                      {sessionDetails?.teacher?.email || '---'}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {sessionDetails?.file_url && (
                <Box className="pdf-preview-container">
                  <PictureAsPdfIcon sx={{ color: '#FF0000' }} />
                  <a
                    href={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(
                      sessionDetails.file_url
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pdf-name"
                  >
                    Prepsheet.pdf
                  </a>
                </Box>
              )}

              {sessionDetails?.status === 'completed' && (
                <Box className="single-session-details-container">
                  <Typography className="section-title" sx={{ width: '100%', display: 'block' }}>
                    Session Recording
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
                    {sessionDetails?.recording_url &&
                    Array.isArray(sessionDetails.recording_url) &&
                    sessionDetails.recording_url.length > 0 ? (
                      sessionDetails.recording_url.map((recording, index) => (
                        <div
                          key={index}
                          onClick={() => handleOpenVideoPlayer(index)}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '12px',
                            border: '1px solid #E5E7EB',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            backgroundColor: '#F9FAFB',
                          }}
                        >
                          <Box
                            sx={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '4px',
                              backgroundColor: '#E0EFFF',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <VideoLibraryIcon sx={{ color: '#0A5EF3' }} />
                          </Box>
                          <span
                            style={{
                              color: '#111827',
                              fontSize: '14px',
                              fontFamily: 'Poppins',
                              fontWeight: '400',
                            }}
                          >
                            Session Recording{' '}
                            {sessionDetails.recording_url.length > 1 ? `(${index + 1})` : ''}
                          </span>
                        </div>
                      ))
                    ) : sessionDetails?.recording_url &&
                      !Array.isArray(sessionDetails.recording_url) ? (
                      <div
                        onClick={() => handleOpenVideoPlayer(0)}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '12px',
                          border: '1px solid #E5E7EB',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          backgroundColor: '#F9FAFB',
                        }}
                      >
                        <Box
                          sx={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '4px',
                            backgroundColor: '#E0EFFF',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <VideoLibraryIcon sx={{ color: '#0A5EF3' }} />
                        </Box>
                        <span
                          style={{
                            color: '#111827',
                            fontSize: '14px',
                            fontFamily: 'Poppins',
                            fontWeight: '400',
                          }}
                        >
                          Session Recording
                        </span>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '12px',
                          border: '1px solid #E5E7EB',
                          borderRadius: '8px',
                          backgroundColor: '#F9FAFB',
                        }}
                      >
                        <span
                          style={{
                            color: '#111827',
                            fontSize: '14px',
                            fontFamily: 'Poppins',
                            fontWeight: '400',
                          }}
                        >
                          No recording available
                        </span>
                      </div>
                    )}
                  </Box>
                </Box>
              )}

              <Box className="single-session-details-container">
                <Typography className="section-title" sx={{ width: '100%', display: 'block' }}>
                  Session Overview
                </Typography>
                <Box sx={{ width: '100%', height: '100%' }}>
                  <Typography className="section-content">
                    {sessionDetails?.description || 'No session description available'}
                  </Typography>
                </Box>
              </Box>

              {sessionDetails?.status === 'completed' &&
              (sessionDetails?.review ||
                (sessionDetails?.reviews && sessionDetails.reviews.length > 0)) ? (
                <Box className="review-container">
                  <Typography className="section-title" sx={{ width: '100%', display: 'block' }}>
                    Reviews
                  </Typography>
                  {(sessionDetails?.review
                    ? [sessionDetails.review]
                    : sessionDetails?.reviews || []
                  ).map((review, index) => (
                    <Box key={review?.id || index} className="review-header">
                      <Avatar
                        src={
                          review?.student?.profile_image ||
                          review?.user?.profile_image ||
                          sessionDetails?.students?.[0]?.user?.profile_image ||
                          '/placeholder.jpg'
                        }
                        alt={
                          review?.student?.name ||
                          review?.user?.name ||
                          sessionDetails?.students?.[0]?.user?.name ||
                          'Student'
                        }
                        sx={{
                          width: 40,
                          height: 40,
                          flexShrink: 0,
                        }}
                      />
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                          className="section-content"
                          sx={{
                            marginBottom: '8px !important',
                            padding: '0 !important',
                            lineHeight: '20px !important',
                          }}
                        >
                          {review?.feedback || review?.comment || 'No comment provided'}
                        </Typography>
                        <Box
                          className="star-rating"
                          sx={{
                            marginTop: '0 !important',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '2px',
                          }}
                        >
                          {[...Array(5)].map((_, i) =>
                            i < (review?.rating || 0) ? (
                              <StarIcon key={i} sx={{ fontSize: '18px', color: '#FFB800' }} />
                            ) : (
                              <StarOutlineIcon
                                key={i}
                                sx={{ fontSize: '18px', color: '#D1D5DB' }}
                              />
                            )
                          )}
                        </Box>
                        {review?.teacher_response && (
                          <Box
                            sx={{
                              marginTop: '12px',
                              padding: '12px',
                              backgroundColor: '#F9FAFB',
                              borderRadius: '8px',
                              borderLeft: '3px solid #0A5EF3',
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: 'Poppins',
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#14171F',
                                marginBottom: '4px',
                              }}
                            >
                              Instructor Response:
                            </Typography>
                            <Typography
                              sx={{
                                fontFamily: 'Poppins',
                                fontSize: '14px',
                                color: '#56585E',
                                lineHeight: '20px',
                              }}
                            >
                              {review.teacher_response}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  ))}
                </Box>
              ) : sessionDetails?.status === 'completed' ? (
                <Box className="review-container">
                  <Typography className="section-title" sx={{ width: '100%', display: 'block' }}>
                    Reviews
                  </Typography>
                  <Box sx={{ width: '100%', padding: '16px 0' }}>
                    <Typography
                      className="section-content"
                      sx={{ padding: '0 !important', textAlign: 'center', color: '#949DA6' }}
                    >
                      No reviews yet
                    </Typography>
                  </Box>
                </Box>
              ) : null}
            </Box>
          </Box>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
              sx: { width: '150px' },
            }}
          >
            <MenuItem
              onClick={() =>
                handleAction(sessionDetails?.students?.[0]?.user?.is_active ? 'disable' : 'enable')
              }
            >
              {sessionDetails?.students?.[0]?.user?.is_active ? 'Disable' : 'Enable'}
            </MenuItem>
          </Menu>
        </Box>
        {openApproveModal && (
          <StudentEnableModal
            setOpenApproveModal={setOpenApproveModal}
            rowId={rowId}
            studentName={studentName}
            isActive={isActive}
          />
        )}

        <Modal
          open={openVideoPlayer}
          onClose={handleCloseVideoPlayer}
          aria-labelledby="video-player-modal"
          aria-describedby="session-recording-player"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '80%',
              maxWidth: '800px',
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 2,
              borderRadius: '8px',
            }}
          >
            <Box
              sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}
            >
              <Typography
                id="video-player-modal"
                variant="h6"
                component="h2"
                sx={{ fontFamily: 'Poppins' }}
              >
                Session Recording
              </Typography>
              <Button
                onClick={handleCloseVideoPlayer}
                sx={{
                  minWidth: 'auto',
                  p: 0.5,
                  color: '#949DA6',
                }}
              >
                ✕
              </Button>
            </Box>
            <Box sx={{ width: '100%', position: 'relative', paddingTop: '56.25%' }}>
              {(() => {
                const recordingUrl = Array.isArray(sessionDetails?.recording_url)
                  ? sessionDetails.recording_url[selectedRecordingIndex]
                  : sessionDetails?.recording_url;

                return recordingUrl?.includes('youtube.com') ? (
                  <iframe
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      borderRadius: '4px',
                    }}
                    src={recordingUrl.replace('watch?v=', 'embed/')}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                ) : videoError ? (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#000',
                      color: 'white',
                      padding: 3,
                    }}
                  >
                    <Typography variant="h6" sx={{ mb: 2, fontFamily: 'Poppins' }}>
                      Video cannot be played
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        mb: 0,
                        textAlign: 'center',
                        fontFamily: 'Poppins',
                      }}
                    >
                      The video URL may have expired or access is restricted.
                    </Typography>
                  </Box>
                ) : (
                  <video
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      borderRadius: '4px',
                      objectFit: 'contain',
                      backgroundColor: '#000',
                    }}
                    src={recordingUrl}
                    controls
                    preload="metadata"
                    onError={e => {
                      console.error('Video playback error:', e);
                      setVideoError(true);
                    }}
                    onLoadStart={() => setVideoError(false)}
                  >
                    <source src={recordingUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                );
              })()}
            </Box>
          </Box>
        </Modal>
      </Box>
    </Layout>
  );
};

export default SingleStudentSessionDetails;
